// DIY Beauty Zone — free + premium recipes per spec.
// Visual fields (emoji + cardBg + category + difficulty) added for the new
// DIY Beauty Zone mockup.

export const RECIPE_FILTERS = ["All", "Skin", "Hair", "Body", "Saved"];

export const RECIPES = [
  {
    id: "turmeric-glow-mask",
    name: "Turmeric Glow Mask",
    type: "skin",
    category: "Skin",
    premium: false,
    featured: true,
    prepTime: "10 mins",
    difficulty: "Easy",
    emoji: "🌿",
    cardBg: "#F5E3C8",
    tags: ["Brightening", "Melanin-rich", "Hyperpigmentation"],
    skinTypes: ["acne-prone", "oily", "combination", "dry", "normal"],
    hairTypes: [],
    ingredients: ["1 tsp turmeric", "1 tbsp raw honey", "2 tbsp plain yogurt"],
    steps: [
      "Combine turmeric, honey, and yogurt into a smooth paste.",
      "Apply an even layer to clean dry skin.",
      "Leave on for 10 minutes (avoid eye area).",
      "Rinse with warm water, gently pat dry.",
      "Follow with moisturizer and SPF in the morning.",
    ],
    tips: [
      "Use only food-grade turmeric (avoid the dyeing kind).",
      "Patch-test first — turmeric can temporarily tint very fair skin.",
    ],
    cautions: ["Avoid sun exposure for 1 hour after.", "Don't apply over open breakouts."],
    note: "Brightens hyperpigmentation. Excellent for melanin-rich skin tones.",
  },
  {
    id: "avocado-curl-cream",
    name: "Avocado Curl Cream",
    type: "hair",
    category: "Hair",
    premium: false,
    prepTime: "5 mins",
    difficulty: "Easy",
    emoji: "🥑",
    cardBg: "#F5E8C2",
    tags: ["Hydration", "Curly", "Coily", "Kinky"],
    hairTypes: ["curly", "coily", "kinky", "4a", "4b", "4c", "3a", "3b", "3c"],
    ingredients: ["1/2 ripe avocado", "2 tbsp coconut oil", "2 tbsp aloe vera gel"],
    steps: [
      "Mash avocado until perfectly smooth (no lumps).",
      "Whisk in melted coconut oil and aloe vera gel.",
      "Section damp hair and apply from mid-length to ends.",
      "Define curls with the praying-hands or shingling technique.",
      "Air dry or diffuse on low.",
    ],
    tips: ["Make fresh for each use — avocado oxidizes quickly."],
    cautions: ["Patch-test for coconut sensitivity if you've had reactions."],
    note: "Deep moisture for curly, coily, and kinky textures.",
  },
  {
    id: "rose-water-toner",
    name: "Rose Water Toner",
    type: "skin",
    category: "Skin",
    premium: false,
    prepTime: "2 mins",
    difficulty: "Easy",
    emoji: "🌹",
    cardBg: "#FDE8F0",
    tags: ["Calming", "All skin types"],
    skinTypes: ["sensitive", "normal", "combination", "dry", "oily"],
    ingredients: ["1/4 cup rosewater", "1 tbsp aloe vera gel", "1 tsp vegetable glycerin"],
    steps: [
      "Combine all ingredients in a spray bottle.",
      "Shake well before each use.",
      "Mist over clean skin morning and night.",
      "Store in the fridge for an extra cooling feel.",
    ],
    tips: ["Use organic rose water — synthetic fragrance versions can irritate."],
    cautions: ["Use within 2 weeks. Keep refrigerated."],
    note: "Calming and hydrating for every skin type.",
  },
  {
    id: "black-castor-scalp-oil",
    name: "Black Castor Scalp Oil",
    type: "hair",
    category: "Hair",
    premium: false,
    prepTime: "5 mins",
    difficulty: "Easy",
    emoji: "🫒",
    cardBg: "#D5E8C8",
    tags: ["Growth", "4C", "Locs"],
    hairTypes: ["4a", "4b", "4c", "coily", "locs"],
    ingredients: [
      "2 tbsp Jamaican black castor oil",
      "5 drops peppermint essential oil",
      "5 drops tea tree essential oil",
    ],
    steps: [
      "Combine oils in a small applicator bottle.",
      "Part hair in sections, apply directly to scalp.",
      "Massage in circular motions for 5 minutes.",
      "Leave in overnight under satin bonnet. Use 2-3x per week.",
    ],
    tips: ["Always dilute peppermint — it's potent."],
    cautions: ["Discontinue if scalp feels burning beyond a gentle tingle."],
    note: "Stimulates growth — excellent for 4C textures and locs.",
  },
  {
    id: "vitamin-c-brightening-serum",
    name: "Vitamin C Serum",
    type: "skin",
    category: "Skin",
    premium: true,
    prepTime: "10 mins",
    difficulty: "Intermediate",
    emoji: "🍋",
    cardBg: "#E8DDF5",
    tags: ["Brightening", "Antioxidant", "Anti-aging"],
    skinTypes: ["normal", "combination", "oily", "dull"],
    ingredients: [
      "1/2 tsp L-ascorbic acid powder",
      "1 tsp distilled water",
      "1 tbsp vegetable glycerin",
      "1/4 tsp vitamin E oil",
    ],
    steps: [
      "Dissolve L-ascorbic acid in distilled water in a dark glass bottle.",
      "Add glycerin and vitamin E, shake gently.",
      "Apply 2-3 drops to clean skin in the morning.",
      "Always follow with SPF. Use within 2 weeks.",
    ],
    tips: ["Use an amber or cobalt glass bottle to prevent oxidation."],
    cautions: ["Always wear SPF — Vit C increases photosensitivity. Patch-test first."],
    note: "Premium recipe — fades dark spots and brightens dull skin.",
  },
  {
    id: "protein-repair-mask",
    name: "Protein Repair Mask",
    type: "hair",
    category: "Hair",
    premium: true,
    prepTime: "15 mins",
    difficulty: "Easy",
    emoji: "🪥",
    cardBg: "#E8DDF5",
    tags: ["Repair", "Breakage", "Bond-building"],
    hairTypes: ["damaged", "chemically-treated", "color-treated", "all"],
    ingredients: ["1 egg", "2 tbsp Greek yogurt", "1 tbsp honey", "1 tbsp olive oil"],
    steps: [
      "Whisk all ingredients until smooth and creamy.",
      "Apply to damp hair from root to tip.",
      "Cover with a shower cap for 15 minutes.",
      "Rinse with cool water then shampoo normally.",
    ],
    tips: ["Don't use protein masks more than once every 2-3 weeks."],
    cautions: ["Rinse with cool water — hot water cooks the egg."],
    note: "Premium recipe — repairs breakage and restores strength.",
  },
  {
    id: "bakuchiol-retinol-alternative",
    name: "Bakuchiol Alternative",
    type: "skin",
    category: "Skin",
    premium: true,
    prepTime: "5 mins",
    difficulty: "Easy",
    emoji: "🌿",
    cardBg: "#F5E3C8",
    tags: ["Anti-aging", "Sensitive", "Pregnancy-safe"],
    skinTypes: ["sensitive", "mature", "dry", "all"],
    ingredients: ["1 tsp bakuchiol oil", "1 tbsp jojoba oil", "1/2 tsp squalane"],
    steps: [
      "Combine all oils in a dark glass dropper bottle.",
      "Apply 3-4 drops to clean skin at night.",
      "Massage gently into face and neck.",
    ],
    tips: ["Layer under moisturizer for extra penetration."],
    cautions: ["Bakuchiol is gentle — but still patch-test on inner arm first."],
    note: "Premium recipe — gentle anti-aging for sensitive skin.",
  },
  {
    id: "aloe-glycerin-moisture-smoothie",
    name: "Aloe Glycerin Smoothie",
    type: "hair",
    category: "Hair",
    premium: true,
    prepTime: "5 mins",
    difficulty: "Easy",
    emoji: "🌱",
    cardBg: "#D5E8C8",
    tags: ["Hydration", "Low-porosity", "All textures"],
    hairTypes: ["all"],
    ingredients: [
      "1/4 cup aloe vera gel",
      "2 tbsp vegetable glycerin",
      "1/4 cup distilled water",
      "1 tsp light oil (grapeseed or jojoba)",
    ],
    steps: [
      "Whisk aloe and glycerin until smooth.",
      "Slowly add water while whisking.",
      "Pour into spray bottle, add oil.",
      "Shake before each use — refresh damp hair daily.",
    ],
    tips: ["Glycerin works best in humid climates — reduce in dry air."],
    cautions: ["Use within 1 week; refrigerate between uses."],
    note: "Premium recipe — deep hydration that lasts all day.",
  },
];
